import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_USERS = restRequest("DASHBOARD.GET_USERS");
export const SET_REPORT_TYPE = "DASHBOARD.SET_REPORT_TYPE";
export const SET_DATE_FROM = "DASHBOARD.SET_DATE_FROM";
export const SET_DATE_TO = "DASHBOARD.SET_DATE_TO";
export const GET_TOTAL_USER_REPORTS = restRequest("DASHBOARD.GET_TOTAL_USER_REPORTS");
export const GET_VEHICLE_LIST = restRequest("DASHBOARD.GET_VEHICLE_LIST");
export const GET_REPORT_TITLES = restRequest("DASHBOARD.GET_REPORT_TITLES");
export const GET_TOTAL_JOB_PACK_REPORTS = restRequest("DASHBOARD.GET_TOTAL_JOB_PACK_REPORTS");
export const SET_EXCEL_REPORT_TYPE = "DASHBOARD.SET_EXCEL_REPORT_TYPE";
export const GET_EXCEL_REPORT_TYPE_LABELS = restRequest("DASHBOARD.GET_EXCEL_REPORT_TYPE_LABELS");
export const GET_EXCEL_DOCUMENT_BUILDING = "DASHBOARD.GET_EXCEL_DOCUMENT_BUILDING";
export const GET_EXCEL_DOCUMENT_FINISHED = "DASHBOARD.GET_EXCEL_DOCUMENT_FINISHED";
